import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./Components/Common/Navbar";
import Sidebar from "./Components/Common/Sidebar";
import AddJob from "./pages/AddJob";
import EditJob from "./pages/EditJob";
import Home from "./pages/Home";
function App() {
  return (
    <Router>
      <Navbar />
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8 ">
        <Sidebar />
        <div className="lg:pl-[14rem]  mt-[5.8125rem]">
          <Routes>
            <Route element={<Home />} path="/" />
            <Route element={<AddJob />} path="/add" />
            <Route element={<EditJob />} path="/edit/:id" />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
